  import { CartLinesUpdateEvent } from '@shopify/events';
  if (!window.__cuBound) {
    window.__cuBound = true;
    document.addEventListener('click', async (e) => {
      const btn = e.target.closest('[data-cu-add]');
      if (!btn) return;
      btn.disabled = true; btn.textContent = 'Adding…';
      const ids = [...document.querySelectorAll('cart-items-component')].map((c) => c.dataset.sectionId).filter(Boolean);
      const deferred = CartLinesUpdateEvent.createPromise();
      btn.dispatchEvent(new CartLinesUpdateEvent({ action: 'add', context: 'product', lines: [{ merchandiseId: btn.dataset.cuAdd, quantity: 1 }], promise: deferred.promise }));
      try {
        const res = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(btn.dataset.cuAdd), quantity: 1 }], sections: ids.join(',') }) }).then((r) => r.json());
        const cart = await fetch('/cart.js').then((r) => r.json());
        deferred.resolve({ cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
          detail: { items: cart.items, source: 'cart-upsell', sections: res.sections, didError: !!res.status } });
      } catch (err) { deferred.reject(err); btn.disabled = false; btn.textContent = 'Add to cart'; }
    });
  }
